import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  item: {
    paddingBottom: "0px",
    paddingTop: "1rem",
  },
  titulo: {
    fontSize: "1.25rem !important",
    fontWeight: "500 !important",
    lineHeight: "2rem !important",
  },
  subTitulo: {
    fontSize: "0.875rem !important",
    color: "#616161",
    lineHeight: "1.375rem !important",
    fontWeight: "500 !important",
  },
}));
